//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'bb_form_d_edit',
        data(){
            return{
                get_host:host.host,
                coldArr:[],
                form:{
                    skin_case:[],
                    feeding_guidance:[],
                    family_sign:'',
                    nurse_sign:''
                },
                showUserSignature:true,
                showSignature:true,
                option:{
                    penColor:"rgb(0, 0, 0)"
                }
            }
        },
        methods:{
            save(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.family_sign = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                this.form.family_sign = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.family_sign = ''
            },
              // 保存客户签名
            saveUserName(){
                let signature ='signature2'
                let png = this.$refs[signature].save()
                this.form.nurse_sign = encodeURI(png)
                this.showUserSignature = true
            },
            //编辑客户签名
            editUserName(){
                this.showUserSignature = false
                this.form.nurse_sign = ''
            },
            //清除客户签名
            clearUserName(){
                let signature ='signature2'
                let refs = this.$refs[signature].clear()
                this.form.nurse_sign = ''
            },
             submitForm(){
                this.form.token=this.$cookie.get('token')
                this.form.number_id=this.$cookie.get('id')
                this.form.maternal_info_id=this.$route.query.id
                this.form.id=this.$route.query.form_id
                this.form.store_id=this.$cookie.get('store_id')
                this.form.baby_id=this.$route.query.baby_id
                let params = this.form
                console.info(params)
                this.form.cold_prevention=this.coldArr.join()
                if(
                    params.room_number==''||params.baby_name==''||params.check_in_time==''||params.weight==''||params.boby_length==''||params.nutritional_status==''||params.complexion==''||params.crying==''||params.reaction==''||
                    params.skin_case.length==0||params.feeding_status==''||params.exc_micturition_case==''||
                    params.exc_micturition_num==''||params.exc_defecation_case==''||params.exc_defecation_num==''||params.muscle_status==''||
                    params.nursing_problem_status==''||params.questionText==''||params.feeding_guidance.length==0||
                    params.cold_prevention==''
                ){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请完善表单',
                    })
                    return
                }
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.otherFormApi.updateNewNewbornFullmoonAssessData(params).then ( res => {
                    this.$vux.loading.hide()
                    console.info(res)
                    if(res.errcode==200){
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:res.data.id,
                                tabVal: this.$route.query.tabVal,
                                name : 'bb_form_d_edit',
                            }
                        })
                    }
                })
            }
        },
        created(){
            let params ={
                token:this.$cookie.get('token'),
                id:this.$route.query.form_id
            }
            this.$vux.loading.show({
                text: '正在加载'
            })
            console.info(params)
            Api.otherFormApi.getNewbornFullmoonAssessFind(params).then (res => {
                this.$vux.loading.hide()
                console.info("详情",res.data)
                if(res.errcode==200){
                   this.form=res.data
                   this.coldArr=res.data.cold_prevention.split(',')
                   this.form.skin_case=res.data.skin_case
                   this.form.feeding_guidance=res.data.feeding_guidance
                   this.form.family_sign=res.data.family_sign.indexOf(this.get_host) != -1 ? res.data.family_sign : this.get_host+res.data.family_sign
                    this.form.nurse_sign=res.data.nurse_sign.indexOf(this.get_host) != -1 ? res.data.nurse_sign : this.get_host+res.data.nurse_sign
                }
            })
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_d_edit.vue